/* Official OpenAI SDK only captures matching references; native Shopify events
 * are relayed separately. No heuristic add-to-cart/checkout/Purchase calls.
 */
(function () {
  window.__apOpenAIEventsInstalled = true;
  if (window.__apOpenAIAttributionInstalled) return;
  window.__apOpenAIAttributionInstalled = true;
  if (new URLSearchParams(location.search).has("preview_theme_id") ||
      new URLSearchParams(location.search).has("webPixelDebug") ||
      new URLSearchParams(location.search).has("ap_qa") || navigator.webdriver) return;
  var initialized = false;
  function sync() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== "function" || typeof privacy.saleOfDataAllowed !== "function") return;
    var allowed = privacy.marketingAllowed() && privacy.saleOfDataAllowed();
    if (!window.oaiq && !allowed) return;
    if (!window.oaiq) {
      var queue = function () { queue.q.push(arguments); };
      queue.q = [];
      window.oaiq = queue;
      var script = document.createElement("script");
      script.async = true;
      script.src = "https://bzrcdn.openai.com/sdk/oaiq.min.js";
      document.head.appendChild(script);
    }
    window.oaiq("consent", !!allowed);
    if (allowed && !initialized) {
      window.oaiq("init", {pixelId: "RDgAWzTM8YQENW34XQStMh"});
      initialized = true;
    }
  }
  document.addEventListener("visitorConsentCollected", sync);
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{name: "consent-tracking-api", version: "0.1"}], function (error) { if (!error) sync(); });
  }
  sync();
})();
